import { createContext, useState } from 'react';

export const CardButtonGroupContext = createContext<{
  isSelected: number | null;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsSelected: (id: number | null) => void;
}>({
  isSelected: null,
  setIsSelected: () => {},
});

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  defaultSelected?: number;
};

export const CardButtonGroup = ({ children, defaultSelected }: Props) => {
  const [isSelected, setIsSelected] = useState<number | null>(defaultSelected || null);

  return (
    <CardButtonGroupContext.Provider value={{ isSelected, setIsSelected }}>
      {children}
    </CardButtonGroupContext.Provider>
  );
};
